/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles } from 'utils/themeV2';



/* ++++++++++ --------------- EXPORTS : ACCOUNT PAYMENT INFO : STYLES --------------- ++++++++++ */
export default theme =>({
    paymentinfo: {
    	'& .variant-withctas': {
    		'& .button': {
    			minWidth: pxToEm(149),
                width: 'auto',
                padding: pxToEm(10),
    			'&:last-child': {
    				marginLeft: pxToEm(10)
    			}
    		}
    	},
      ...buttonStyles   
    }
});
